import React from 'react';
import FlagSection from '../../../sections/AdminDashboard/Configuration/Flag';

const Flag = () => <FlagSection />;

export default Flag;
